module.exports = __webpack_public_path__ + "img/prospect-portal.7594590d.svg";